import general from './forms/general';
import standards from './forms/standards';
import createIssues from './forms/create-issues';

export interface Question {
  label: string;
  type: string;
  required?: boolean;
  values?: Array<string>;
  scored?: boolean;
  score?: number;
  lookup?: string;
  errorMessage?: string;
  photo?: 'required' | 'optional';
}

export interface Section {
  label: string;
  type: string;
  questions: Array<Question>;
}

export interface Form {
  id: string;
  title: string;
  description: string;
  questions: Array<Question | Section>;
}

export const forms: Array<Form> = [general, standards, createIssues];
